import { AnswerSetResult } from "../../store/viewmodels/AnswerSetViewModel";
import { Student } from "../../store/viewmodels/StudentViewModel";
import AnswerSetResults from './results/resultItems/AnswerSetResults';


export interface AnswerSetResultsModalProps {
    close: () => void,
    answerSet: AnswerSetResult,
    student?: Student
}

function AnswerSetResultsModal(props: AnswerSetResultsModalProps): JSX.Element {

    if (!props.student) return <div></div>;
    const answerSetInfo: JSX.Element = <AnswerSetResults answerSet={props.answerSet} student={props.student} />;

    return (
        <div className="h-full w-full p-6 overflow-auto">
            <div className="">
                <h2 className="mb-4 text-center text-2xl font-extrabold text-gray-900">{props.answerSet.itemset.name}</h2>
                <div className="w-full">
                    {answerSetInfo}
                    <div className="mt-4 w-1/2 flex">
                        <div className="w-1/2">
                            <button
                                onClick={props.close}
                                type="button"
                                className="block w-full text-sm font-medium rounded-md border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                Sulje
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AnswerSetResultsModal;